import * as React from "react";
import { VStack, Text } from "@chakra-ui/react";

interface TextFieldProps {
  label: string;
  value: React.ReactNode;
}

const TextField: React.FC<TextFieldProps> = ({ label, value }) => (
  <VStack align="start" spacing="4px">
    <Text color="gray.500" fontWeight="semibold">
      {label}:
    </Text>
    <Text color="gray.700" fontWeight="bold">
      {value}
    </Text>
  </VStack>
);

export default TextField;
